import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import App from '../../components/App/App';
import InfoPagePolicy from '../../components/InfoPages/InfoPagePolicy';

const TermsOfService = () => {
  return (
    <App>
      <InfoPagePolicy />
    </App>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
  revalidate: 60 * 60,
});

export default TermsOfService;
